import { render } from "./serviciogrupoetapa.vue?vue&type=template&id=2800516a"
import script from "./serviciogrupoetapa.vue?vue&type=script&lang=js"
export * from "./serviciogrupoetapa.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__